import {
  mockChildDependents,
  mockSpouse,
  mockAdultDependents,
  mockSubscriber,
} from './dependents.mocks';
import { mockAddress } from './address.mocks';

export const { state_name, ...mockDemographicsCoverageOptionsAddress } =
  mockAddress;

export const mockCoveredMemberOptions = {
  coveredOption: {
    cards: ['subscriber'],
    icon: 'add_yourself',
    label: 'Subscriber Only',
    value: 'subscriber',
  },
  initialValue: {
    children: [
      {
        ...mockChildDependents[0],
        address: {
          ...mockDemographicsCoverageOptionsAddress,
          street_name_1: null,
          street_name_2: null,
        },
        mailing_address: {
          ...mockDemographicsCoverageOptionsAddress,
          street_name_1: null,
          street_name_2: null,
        },
        home_phone: '103-468-6063',
        medicare_enrolled: false,
        phone: '785-435-8975',
        primary_phone: '785-435-8975',
      },
    ],
    spouse: {
      ...mockSpouse,
      address: {
        ...mockDemographicsCoverageOptionsAddress,
        street_name_1: null,
        street_name_2: null,
      },
      mailing_address: {
        ...mockDemographicsCoverageOptionsAddress,
        street_name_1: null,
        street_name_2: null,
      },
      home_phone: '103-468-6063',
      medicare_enrolled: false,
      phone: '785-435-8975',
      primary_phone: '978-435-8975',
    },
    stepParents: [
      {
        ...mockAdultDependents[0],
        address: {
          ...mockDemographicsCoverageOptionsAddress,
          street_name_1: null,
          street_name_2: null,
        },
        mailing_address: {
          ...mockDemographicsCoverageOptionsAddress,
          street_name_1: null,
          street_name_2: null,
        },
        home_phone: '853-468-6063',
        medicare_enrolled: false,
        phone: '885-435-8975',
        primary_phone: '991-435-8975',
      },
    ],
    subscriber: {
      ...mockSubscriber,
      date_of_birth: '1999-02-23',
      address: {
        ...mockDemographicsCoverageOptionsAddress,
        street_name_1: null,
        street_name_2: null,
      },
      mailing_address: {
        ...mockDemographicsCoverageOptionsAddress,
        street_name_1: null,
        street_name_2: null,
      },
      home_phone: '103-468-6063',
      medicare_enrolled: false,
      phone: '785-435-8975',
      primary_phone: '898-435-8975',
    },
    coverage_effective_date: '2024-01-01',
  },
};
